import React from "react"
import { Carriers } from "modules/Carriers/Carriers"
import { PoppinsOrder } from "modules/Carriers/components/Poppins/PoppinsOrder"

const routes = [
  {
    name: "",
    inSidebar: true,
    authorizedRoles: [],
    environments: ["development", "staging", "production"],
    elements: [
      {
        path: "/carriers/parcels-without-contact",
        icon: <i className="metismenu-icon font-style-normal">📦</i>,
        exact: true,
        component: Carriers,
        inSidebar: true,
        label: "Colis sans coordonnées",
        authorizedRoles: [],
        children: [],
      },
      {
        path: "/carriers/poppins-order",
        icon: <i className="metismenu-icon font-style-normal">📦</i>,
        exact: true,
        component: PoppinsOrder,
        inSidebar: true,
        label: "Poppins - Créer une commande",
        authorizedRoles: [],
        children: [],
      },
    ],
  },
]

export default routes
